module.exports = __webpack_public_path__ + "static/media/app1.eb453fd6.png";